module.exports = __webpack_public_path__ + "img/c7.cefc97db.png";